import {html} from 'lit';
import {customElement, property, state} from 'lit/decorators.js';
import B2bElement from '../../../../b2b-element.js';
import defaultStyle from '../../../b2b-public-styles.scss';
import B2bPublicServiceClientProxy from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/B2bPublicServiceClientProxy.js';
import PasswordCredentials from '../../../../gen/com/arabellesolutions/sdc/b2b/pub/utils/PasswordCredentials.js';

@customElement('b2b-public-reset-password')
export class B2bPublicResetPassword extends B2bElement {
  static styles = [defaultStyle];

  /** @type {PasswordCredentials} */
  @state()
  accessor __credentials = new PasswordCredentials();

  @state()
  accessor __code;

  @property({type: Object, attribute: false})
  accessor route;

  __b2bPublicServiceProxy = new B2bPublicServiceClientProxy(super.msgpackClientPublic());

  /**
   * @param {PasswordCredentials} entry
   * @return {Promise<boolean>}
   */
  __submit = entry => this.__b2bPublicServiceProxy.updateUserPassword(this.__code, entry);

  render() {
    return html`
      <mta-page-title page-name="resetPassword" title="Reset Password"></mta-page-title>
      <div class="page-container">
        <mta-form
            .value="${this.__credentials}"
            @success="${this.__submitted}"
            @keydown="${this.__onKeyDown}"
            success-message="Password reset successful">
          <div class="menu-top-left">
            <common-mta-logo class="logo" url=""></common-mta-logo>
          </div>
          <div class="form-header">
            <h2>Reset Password</h2>
            <p>Password must be 8-60 characters and include at least the following: uppercase, lowercase, number and symbol.</p>
          </div>
          <mta-form-input name="password" type="password" label="Enter new password" required></mta-form-input>
          <mta-form-input name="confirmPassword" type="password" label="Confirm new password" required></mta-form-input>
          <mta-form-buttons hide-cancel="true" submit-label="Reset Password" .submit="${this.__submit}"></mta-form-buttons>
        </mta-form>
      </div>
    `;
  }

  connectedCallback() {
    super.connectedCallback();
    this.__code = this.route.args.code;
  }

  __submitted() {
    this.redirect('#/auth/login');
  }

  __onKeyDown(e) {
    if (e.keyCode === 13) {
      const form = this.shadowRoot.querySelector("mta-form");
      const buttons = this.shadowRoot.querySelector("mta-form-buttons");

      form.resetStateHistory();
      buttons.submit(this.__code).then(() => this.__submitted());
    }
  }
}
